import { Stack, Tabs, Title } from '@mantine/core'
import { createFileRoute, Outlet, useLocation } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/_admin/shortages')({
  component: RouteComponent,
})

function RouteComponent() {
  const navigate = Route.useNavigate()
  const { pathname } = useLocation()
  const section = pathname.split('/').pop()

  return (
    <Stack gap="xl">
      <Title order={1}>Zarządzanie brakami</Title>
      <Tabs
        value={section || 'shortages'}
        onChange={(value) => navigate({ to: value === 'shortages' ? '/shortages/' : `/shortages/${value}` })}
      >
        <Tabs.List>
          <Tabs.Tab value="shortages">Braki</Tabs.Tab>
          <Tabs.Tab value="orders">Zamówienia</Tabs.Tab>
        </Tabs.List>
        <Outlet />
      </Tabs>
    </Stack>
  )
}
